import { render, staticRenderFns } from "./DealerCourseList.vue?vue&type=template&id=bf938aa4&"
import script from "./DealerCourseList.vue?vue&type=script&lang=js&"
export * from "./DealerCourseList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports